import { useSelector } from 'react-redux';
import { get } from 'lodash';

export function useSamples(sampleId?: number) {
  const samples = useSelector((state: any) =>
    sampleId ? get(state.samples, sampleId) : state.samples,
  );

  const getSampleByNexsetID = (id: number) => {
    if (!id) return;
    return samples[id];
  };

  return {
    samples,
    getSampleByNexsetID: sampleId ? undefined : getSampleByNexsetID,
  };
}
